import React, {Component} from 'react'
import Panel from '../Panel'
import {style, media, merge} from 'glamor'
import * as colors from '../../colors'
import Page from './Page'
import PageTitle from '../PageTitle'
import SectionTitle from '../SectionTitle'

export default class extends Component {

  shouldComponentUpdate(){
    return false
  }

  render(){
    return (
      <Page>
        <PageTitle>À propos</PageTitle>

        <div
          data-animate
          {...style({
            marginBottom: '1rem',
            // color: colors.lightSilver,
            // fontSize: '1.5rem',
          })}
        >
          Eric Hélias,<br/>
          Fondateur de BUYIDEAS
        </div>

        <div
          {...merge(
            style({
              marginBottom: '1rem',
            }),
            media('(min-width:800px)', {
              position: 'absolute',
              padding: '4rem',
              zIndex: 0,
              top: 0,
              right: 0
            })
          )}
        >
          <img
            data-animate
            {...style({
              display: 'block',
              width: '100%'
            })}
            src='/images/eric-helias.jpg'
          />
        </div>

        <div
        {...style({
          position: 'relative',
          zIndex: 1
        })}
        >

          <div
            data-animate
            {...style({
              marginBottom: '2rem',
              fontStyle: 'italic'
            })}
          >
            Concepteur Rédacteur: BDDP, BDDP&FILS, TBWA, Publicis.<br/>
            Directeur de création chez Young&Rubicam.
          </div>

          <div
            data-animate
            {...merge(
              style({
                marginBottom: '2rem',
                color: colors.lightSilver
              }),
              media('(min-width:800px)', {
                width: '50%'
              })
            )}
          >
            <SectionTitle>Clients</SectionTitle>
            <p>
              FDJ, Renault, Mc DO, Ricard, Sony, ClubMed, venteprivées, SNCF, Relais & Châteaux, FFF, Roularta-lexpress, LCP, Europe 1, Bien-être & Santé, Balsamik, Pequignet…
            </p>
          </div>

          <Panel
            data-animate
            {...merge(
              style({
                color: colors.lightSilver
              }),
              media('(min-width:800px)', {
                width: '70%'
              })
            )}
          >
            <SectionTitle>Prix et distinctions</SectionTitle>
            <p>
              1er créatif français a remporter un grand prix au Festival International de Cannes (Sony Playstation 2003).
            </p>
            <p>
              1er créatif français a gagner 14 lions au Festival International de Cannes.
            </p>
            <p>
              1er créatif français à gagner un silver pencil aux D&AD de Londres.
            </p>
            <p>
              1er créatif français à remporter un prix Effie du e-commerce  pour une agence de moins de 5 ans pour l’agence La Famille.
            </p>
          </Panel>

        </div>
      </Page>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/pages/About.js
 **/